{
	"message": "hello i18n !!",
	"logo": "로고",
	"gnb" : {
		"market_place": "마켓"
	}
  }